import { DrawerContent } from '@/components/drawer-content';
import { useBreakPoints } from '@/hooks/use-break-points';
import { cn } from '@/utils/cn';
import { Slot } from 'expo-router';
import { View } from 'react-native';

export default function CoreLayout() {
  const { isMobile } = useBreakPoints();

  return (
    <View className={cn(isMobile ? 'h-full' : 'flex-row')}>
      {!isMobile && (
        <View className="sticky top-0 h-screen items-end border-r border-[#1d312e]">
          <View className="sticky h-full w-[275px]">
            <DrawerContent />
          </View>
        </View>
      )}
      <View
        className={cn('flex-1 bg-background', isMobile && 'h-full w-full pb-0')}
      >
        <Slot />
      </View>
    </View>
  );
}
